<button
  class="d-flex align-items-center"
  mat-menu-item
  (click)="useLanguage(language.key)"
  *ngFor="let language of languages"
>
  <img [src]="language.flag" class="pr-2" width="32px" />
  <span> {{ language.label }} </span>
</button>
